import { render } from "./partnerDashboard.vue?vue&type=template&id=4eb9e8c0&scoped=true"
import script from "./partnerDashboard.vue?vue&type=script&lang=js"
export * from "./partnerDashboard.vue?vue&type=script&lang=js"

import "./partnerDashboard.vue?vue&type=style&index=0&id=4eb9e8c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb9e8c0"]])

export default __exports__